var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { Body } from 'syf-component-library/ui/typography';
import theme from '../../../theme';
import { t } from '../../../strings/i18n/i18n';
import { DOUBLE_CHARGE_QUESTION_ID, RECURRING_TABLE_LIST_QUESTION_ID } from '../../../const/questionIds';
import TableListRow from './TableListRow';
import TableListHeader from './TableListHeader';
var TableContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  & > * {\n    border-bottom: 1px solid ", ";\n  }\n"], ["\n  border-top: 1px solid ", ";\n  & > * {\n    border-bottom: 1px solid ", ";\n  }\n"])), theme.colors.lightGrey, theme.colors.lightGrey);
var EmptyTransactionsText = styled(Body)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  text-align: center;\n"], ["\n  text-align: center;\n"])));
var duplicateTransactionsQuestionIDs = [
    RECURRING_TABLE_LIST_QUESTION_ID,
    DOUBLE_CHARGE_QUESTION_ID
];
var TableListQuestion = function () {
    var _a = useSelector(function (state) { return state; }), formError = _a.ui.formError, _b = _a.questionnaire, doubleChargedTransactions = _b.doubleChargedTransactions, duplicateTransactions = _b.duplicateTransactions, currentQuestion = _b.currentQuestion;
    var id = currentQuestion.id;
    var isDoubleChargeQuestion = id === DOUBLE_CHARGE_QUESTION_ID;
    if (!duplicateTransactionsQuestionIDs.includes(id)) {
        return null;
    }
    if (!isDoubleChargeQuestion && !duplicateTransactions.length) {
        return (_jsx(EmptyTransactionsText, { children: t('questionnaire.noTransactionsFound') }));
    }
    if (isDoubleChargeQuestion && doubleChargedTransactions.length === 1) {
        return (_jsx(TableContainer, { children: doubleChargedTransactions.map(function (txn) { return (_jsx(TableListRow, { questionID: id, formError: formError, txn: txn, showCheckBox: false }, txn.transactionId)); }) }));
    }
    return (_jsxs(TableContainer, { children: [_jsx(TableListHeader, {}), duplicateTransactions.map(function (txn) { return (_jsx(TableListRow, { questionID: id, formError: formError, txn: txn, showCheckBox: true }, txn.transactionId)); })] }));
};
export default TableListQuestion;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map